import liteCheersEnMp4 from './lite-league-cheers-en.mp4';
import liteCheersFrMp4 from './lite-league-cheers-fr.mp4';
import liteMillerEnMp4 from './lite-league-miller-time-en.mp4';
import liteMillerFrMp4 from './lite-league-miller-time-fr.mp4';

import liteCheersEnWebm from './lite-league-cheers-en.webm';
import liteCheersFrWebm from './lite-league-cheers-fr.webm';
import liteMillerEnWebm from './lite-league-miller-time-en.webm';
import liteMillerFrWebm from './lite-league-miller-time-fr.webm';

export default {
    fr: [
        { id: 'cheers_fr', mp4: liteCheersFrMp4, webm: liteCheersFrWebm },
        { id: 'miller_fr', mp4: liteMillerFrMp4, webm: liteMillerFrWebm },
    ],
    en: [
        { id: 'cheers_en', mp4: liteCheersEnMp4, webm: liteMillerEnMp4 },
        { id: 'miller_en', mp4: liteCheersEnWebm, webm: liteMillerEnWebm },
    ],
};
